import React from 'react'
import { tokens } from '../../../styles/desertFloraTheme'

const costTypes = [
  { key: 'labor', label: 'Labor' },
  { key: 'material', label: 'Material' },
  { key: 'equipment', label: 'Equipment' },
  { key: 'subcontract', label: 'Subcontract' }
]

const MarkupDefaultsPanel = ({ project }) => {
  const rules = project?.markupRules || []

  const getMarkup = (costType) => {
    const rule = rules.find(r => r.costType === costType)
    if (!rule || rule.markupPct == null) return '—'
    return `${rule.markupPct}%`
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{
          fontFamily: tokens.fontMono, fontSize: 10.5, fontWeight: 600,
          letterSpacing: '.12em', textTransform: 'uppercase', color: tokens.ink3
        }}>
          Project markup defaults
        </div>
        <span style={{ fontSize: 11, color: tokens.primary, cursor: 'pointer' }}>
          edit
        </span>
      </div>

      {costTypes.map((ct, idx) => (
        <div
          key={ct.key}
          style={{
            display: 'flex', justifyContent: 'space-between',
            padding: '6px 0',
            borderBottom: idx < costTypes.length - 1 ? `1px dashed ${tokens.line}` : 'none'
          }}
        >
          <span style={{ fontSize: 12, color: tokens.ink2 }}>
            {ct.label}
          </span>
          <span style={{ fontFamily: tokens.fontMono, fontSize: 12, color: tokens.ink }}>
            {getMarkup(ct.key)}
          </span>
        </div>
      ))}

      <div style={{ fontSize: 11, color: tokens.ink4, marginTop: 8 }}>
        Defaults applied at project scope. Override per line above.
      </div>
    </div>
  )
}

export default MarkupDefaultsPanel
